import { Funnel, FunnelX } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Kbd } from '@/components/ui/kbd'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface FilterToggleButtonProps {
  open: boolean
  onToggle: () => void
}

/** Show/Hide Filters toggle, shared by the data-table toolbar and the duties
 *  metrics rail. Both bind ⌘B to the same action, which is what the tooltip
 *  advertises; the caller owns the shortcut and the open state. */
export function FilterToggleButton({
  open,
  onToggle,
}: FilterToggleButtonProps) {
  const label = open ? 'Hide Filters' : 'Show Filters'

  return (
    <TooltipProvider>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            onClick={onToggle}
            aria-pressed={open}
            // The visible label is hidden below md, so name the button too.
            aria-label={label}
            className="text-primary-high-contrast h-9 shrink-0 gap-2 px-3 font-medium">
            {open ? (
              <FunnelX className="h-4 w-4" />
            ) : (
              <Funnel className="h-4 w-4" />
            )}
            <span className="hidden md:block">{label}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>
            Toggle filters with{' '}
            <Kbd className="text-muted-foreground group-hover:text-accent-foreground ml-1">
              <span className="mr-1">⌘</span>
              <span>B</span>
            </Kbd>
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
